module.exports = __webpack_public_path__ + "static/img/pixel-logo-square.ef30346.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pixel-logo-square.jpg
// module id = U7Ka
// module chunks = 1